import CalendarEventsStoreIndex from './schema/CalendarEventsStoreIndex';
import { CalendarEvent } from 'mini-calendar-event-types';

export default class CalendarInstanceKeyItemIdIndex implements CalendarEventsStoreIndex {
    private instanceKeyItemIdMap: Map<string, Set<string>>;

    constructor() {
        this.instanceKeyItemIdMap = new Map<string, Set<string>>();
    }

    getAllItemIds(instanceKey: string): string[] {
        let itemIds: string[] = [];
        if (this.instanceKeyItemIdMap.has(instanceKey)) {
            itemIds = this.instanceKeyItemIdMap.get(instanceKey).keys();
        }
        return [...itemIds];
    }

    onAddCalendarEvent(event: CalendarEvent): void {
        const instanceKey = event.InstanceKey;
        const itemId = event.ItemId.Id;
        if (!this.instanceKeyItemIdMap.has(instanceKey)) {
            this.instanceKeyItemIdMap.set(instanceKey, new Set<string>());
        }
        this.instanceKeyItemIdMap.get(instanceKey).add(itemId);
    }

    onDeleteCalendarEvent(event: CalendarEvent): void {
        const instanceKey = event.InstanceKey;
        const itemId = event.ItemId.Id;
        if (this.instanceKeyItemIdMap.has(instanceKey)) {
            this.instanceKeyItemIdMap.get(instanceKey).delete(itemId);
        }
    }

    clearIndex() {
        this.instanceKeyItemIdMap = new Map<string, Set<string>>();
    }
}
